// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2re-c","importantInfo":"styles_importantInfo__2gl7P"};